import { BlueprintEditorTool } from '../definitions'
import BlueprintManager from './BlueprintManager/BlueprintManager'
import CameraManager from './CameraManager/CameraManager'
import Editor3DElements from './Editor3DElements/Editor3DElements'
import MaskPCD from './MaskPCD/MaskPCD'
import MeasurementLabel from './MeasurementLabel/MeasurementLabel'
import Pen from './Pen/Pen'
import Polygon from './Polygon/Polygon'
import Selector from './Selector/Selector'
import Circle from './Shapes/Circle/Circle'
import Rectangle from './Shapes/Rectangle/Rectangle'
import TextAnnotation from './TextAnnotation/TextAnnotation'

export const Tools: BlueprintEditorTool[] = [
  // Editor tools
  Selector,
  Pen,
  Polygon,
  Rectangle,
  Circle,
  TextAnnotation,
  MeasurementLabel,

  // Global tools
  BlueprintManager,
  CameraManager,
  MaskPCD,
  Editor3DElements,
]
